import axios from "axios";
import Cookies from "universal-cookie";
import { LOCAL_BASE_URL } from "../utils/helper/constants/constants";
import { isUserLogged } from "../utils/helpers/function";

const cookies = new Cookies(null, { path: "/" });

const verifyToken = () => {
  // Get token from cookies
  const token = cookies.get("zk-vg");
  if (!token) {
    console.error("Token is not available.");
    // navigate("/login");
  }
  return token;
};

const instance = axios.create({
  baseURL: "https://api.digiauthentic.com/api",
  // baseURL: "http://localhost:5050/api",
  // headers: { "Content-Type": "application/json" },
});

const config = {
  baseURL: LOCAL_BASE_URL,
};

function isLogged() {
  const cookie = isUserLogged()?.cookie;
  return cookie;
}

// NoAuthInstance for making requests that do not require authentication
export const NoAuthInstance = axios.create({
  ...config,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Auth instance for authenticated requests
const auth = ({ url, method, data, params, header }) => {
  const token = verifyToken(); // Get token from cookies

  // If no token, reject the request
  if (!token) {
    throw new Error("No token available. Please log in.");
  }

  return instance({
    url,
    method,
    data,
    headers: {
      Authorization: "Bearer " + token, // Attach token to request header
      ...header,
    },
    params,
  });
};

// Axios instance for auth-specific requests
export const authInstance = () => {
  const token = verifyToken();
  return axios.create({
    ...config,
    headers: {
      "Access-Control-Allow-Credentials": true,
      Authorization: "Bearer " + token,
    },
  });
};

// Interceptor to handle token expiration (optional - depends on your backend logic)
instance.interceptors.response.use(
  (response) => response, // Return response if no error
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      // Refresh token logic (if applicable)
      const refreshedToken = await refreshToken(); // Add your refresh logic here
      // cookies.set("zk-vg", refreshedToken);
      originalRequest.headers["Authorization"] = "Bearer " + refreshedToken;
      return instance(originalRequest); // Retry the original request with new token
    }
    return Promise.reject(error); // Reject if not a 401 or other error
  }
);

// Function to refresh the token (if required by your system)
const refreshToken = async () => {
  // Implement token refresh logic
  // For example, call an endpoint to refresh the token and return the new token
  // return await refreshTokenAPI();
};

// Export the auth function
export { auth, instance };
